import React from 'react';
import './OurMission.css';

function OurMission() {
  return (
    <div className="mission">
      <h2>Our Mission</h2>
      <p>Elevate Your Sleep, Elevate Your Life.</p>

<p>Experience the ultimate in comfort and support with our premium range of foam, spring, and orthopedic mattresses. Crafted with precision and innovation, our mattresses are designed to cater to diverse sleep preferences and needs.</p>

<h1>Why choose us?</h1>
<ul><strong>Cutting-Edge Technology:</strong> We harness the latest advancements in sleep technology to deliver mattresses that are not just comfortable but also promote healthy sleep.</ul>
<ul><strong>Premium Materials:</strong> Our mattresses are meticulously crafted using high-quality materials that are soft, durable, and hypoallergenic.</ul>
<ul><strong>Tailored Comfort:</strong> Whether you prefer a soft, medium, or firm mattress, we have the perfect option to suit your unique comfort preferences.</ul>
<ul><strong>Orthopedic Support:</strong> Our orthopedic mattresses are designed to alleviate pressure points, reduce back pain, and promote proper spinal alignment.</ul>
<h3>Indulge in the luxury of a good night's sleep. Explore our range of mattresses today.      </h3>
    </div>
  );
}

export default OurMission;